import React, { useState } from 'react';
import { 
  Select, MenuItem, TextField
} from '@material-ui/core';

import MenuType from "./MenuType";

import styles from './Menu.module.css';

// PB 메뉴 
const PBMenu = ({ menu, pbMenus, onSelectMenu, onUpdateMemo }) => {
  const [ select, setSelect ] = useState(menu.menu?.id ?? -1);
  const [ memo, setMemo ] = useState(menu.memo);

  const handleChange = evt => {
    const id = evt.target.value;
    const selectedMenu = pbMenus.find(m => m.id === id);
    setSelect(id);
    onSelectMenu({
      date: menu.date,
      serviceTime: menu.serviceTime,
      menu: selectedMenu
    });
  }

  const handleChangeAdtnMenu = evt => {
    setMemo(evt.target.value);
  }

  const handleOnBlur = () => {
    onUpdateMemo({
      date: menu.date,
      serviceTime: menu.serviceTime,
      menuId: menu.menuId,
      memo: memo
    })
  }

  return (
    <div className={styles.menu}>
      {/* supplier title */}
      <div className={styles.supplier}>
        <div className={styles.supplierTitle}>
          푸딩
        </div>
      </div>
      {/* main menu */}
      <div className={styles.mainMenu}>
        <MenuType type={'메인메뉴'} />
        <Select
          value={select}
          onChange={handleChange}
          disabled={menu.published}
        >
          <MenuItem value={-1}>선택 안함</MenuItem>
          {pbMenus.map(el => (
            <MenuItem key={el.id} value={el.id}>{el.name}</MenuItem>
          ))}
        </Select>
      </div>
      {/* memo */}
      <div className={styles.adtnMenu}>
        <MenuType type={'추가메뉴'} />
        <div
          className={styles.memo}
        >
          <TextField
            value={memo ?? ''}
            onChange={handleChangeAdtnMenu}
            onBlur={handleOnBlur}
            variant="outlined"
            placeholder="메인 옆에 '추가메뉴명'으로 적용됨"
            size="small"
            disabled={select === -1 || menu.published}
          />
        </div>
      </div>
    </div>
  );
}

export default PBMenu;